/* eslint-disable react/no-array-index-key */
import { forwardRef, useEffect, useState } from 'react';
import { Carousel as ResponsiveCarousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const Carousel = forwardRef(({ images, ...props }, ref) => {
  const [blobUrls, setBlobUrls] = useState([]);

  useEffect(() => {
    if (!images || images.length === 0) {
      setBlobUrls([]);

      return;
    }

    const urls = images.map((img) => {
      let byteArray;

      if (img?.data instanceof Uint8Array) {
        byteArray = img.data;
      } else if (img?.data) {
        byteArray = new Uint8Array(img.data);
      } else if (img instanceof Uint8Array) {
        byteArray = img;
      } else {
        byteArray = new Uint8Array(img);
      }

      const blob = new Blob([byteArray], { type: 'image/jpeg' });

      return URL.createObjectURL(blob);
    });

    setBlobUrls(urls);

    // Cleanup blob URLs when component unmounts or images change
    return () => urls.forEach((url) => URL.revokeObjectURL(url));
  }, [images]);

  if (!blobUrls.length) {
    return <div style={{ height: 200, background: '#eee' }}>No images available</div>;
  }

  const defaultProps = {
    showArrows: true,
    showStatus: false,
    infiniteLoop: true,
    useKeyboardArrows: true,
    emulateTouch: true,
    showIndicators: true,
    autoPlay: true,
    interval: 3000, // 3 seconds
    dynamicHeight: false,
    width: '400px',
    selectedItem: 0,
    swipeable: true,
    autoFocus: false,
    transitionTime: 400, // 400ms
    axis: 'horizontal', // 'horizontal' or 'vertical'
    stopOnHover: true,
    showThumbs: false,
  };

  return (
    <ResponsiveCarousel ref={ref} {...defaultProps} {...props}>
      {blobUrls.map((url, index) => (
        <div key={index}>
          <img src={url} alt={`Slide ${index + 1}`} />
        </div>
      ))}
    </ResponsiveCarousel>
  );
});

Carousel.displayName = 'Carousel';
export default Carousel;
